module.exports = __webpack_public_path__ + "static/1-financial-699f8ce1ad2eee7f81060535339faac1.jpg";